import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFolderOff = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "folder_off_2",
		d: "M28.4304 24.664L26.6664 22.9V11.077C26.6664 10.9572 26.628 10.8589 26.5511 10.782C26.4742 10.7051 26.3758 10.6667 26.2561 10.6667H14.4664L9.79973 6H12.6511L15.3177 8.66667H26.2561C26.9296 8.66667 27.4997 8.9 27.9664 9.36667C28.4331 9.83334 28.6664 10.4034 28.6664 11.077V23.5897C28.6664 23.7914 28.6484 23.9829 28.6124 24.164C28.5766 24.3453 28.516 24.512 28.4304 24.664ZM27.5177 30.3487L23.1691 26H5.7434C5.06984 26 4.49973 25.7667 4.03306 25.3C3.5664 24.8333 3.33306 24.2632 3.33306 23.5897V8.41034C3.33306 7.73678 3.5664 7.16667 4.03306 6.7C4.49973 6.23334 5.06984 6 5.7434 6H5.99973L7.99973 8H5.7434C5.62362 8 5.52529 8.03845 5.4484 8.11534C5.37151 8.19223 5.33306 8.29056 5.33306 8.41034V23.5897C5.33306 23.7094 5.37151 23.8078 5.4484 23.8847C5.52529 23.9616 5.62362 24 5.7434 24H21.1691L2.16406 4.97433L3.56906 3.56934L28.9434 28.9437L27.5177 30.3487Z",
		fill: "currentColor"
	})
});
export default SvgFolderOff;
